type BreakpointList = {
  [key: string]: number;
};

export const breakpoints: BreakpointList = {
  mobile: 360,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1280,
  wide: 1600
};

export const mediaQuery = (breakpointName: string): MediaQueryList => {
  return window.matchMedia(`(min-width: ${breakpoints[breakpointName]}px)`);
};
